/**
 * «Подзвонити» з рядка задачі «Сьогодні» (Г2-W1b; web-calls.md, розд. 2; calls.md, розд. 4): дзвінок
 * записується на господаря задачі, а номер сервер бере з кореня господаря (`phone.of: 'root'`).
 *
 * Поле телефону кореня — перше поле типу `phone` сутності кореня в `/meta`, індекс 0: те саме правило,
 * за яким сервер дає `phone` рядка (tasks-today.md, розд. 3, «Номер для дзвінка»; `/meta` не віддає
 * прихованих глядачу полів). Корінь — `root` рядка, а без нього господар сам собі корінь: номер у
 * рядку є, отже корінь видимий і єдиний.
 *
 * Fail closed — `null`, і рядок лише відкриває набір і копіює номер: немає номера чи господаря,
 * немає сутності з поведінкою `calls` у `/meta` чи права створювати дзвінок, господар без поведінки
 * `activities`, сутності кореня чи поля телефону немає в `/meta`.
 */
import type { AppMeta, TodayItem } from '@clientline/contracts';
import { entityOf } from '../../platform/meta.ts';
import { callEntityOf, canRecordCalls } from '../call/call-card.ts';
import type { TelCall } from '../call/start-call.ts';

export function todayTelCall(item: TodayItem, meta: AppMeta | undefined): TelCall | null {
  if (!meta || !item.host || !item.phone) return null;
  if (!canRecordCalls(callEntityOf(meta))) return null;
  const host = entityOf(meta, item.host.entity);
  if (!host || !('activities' in (host.behaviors ?? {}))) return null;
  const root = item.root ? entityOf(meta, item.root.entity) : host;
  const field = root?.fields.find((f) => f.type === 'phone');
  if (!field) return null;
  return {
    host: { entity: item.host.entity, id: item.host.id },
    phone: { field: field.key, index: 0, of: 'root' },
    // Задача-план — лише відкрита задача-дзвінок (calls.md, розд. 4): інша дала б
    // `422 calls.plan_unavailable`, і дзвінок не записався б зовсім.
    ...(item.category === 'call' && item.state === 'open' ? { plan: item.id } : {}),
  };
}
